import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import MissingDataBubble from 'Components/UI/MissingDataBubble';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    alignItems: 'flex-start',
  },
  historyContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.facet.accentBlue,
  },
  historyContainerSelected: {
    color: theme.palette.common.white,
  },
  historyIcon: {
    fontSize: '12px',
    marginRight: theme.spacing(0.5),
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
});

const PlanningDataTab = ({
  className,
  classes,
  lastUpdateTime,
  isMissingData,
  isScoresError,
  progress,
  SubtitleComponent,
  ...rest
}) => {
  const { children } = rest;
  const selected = rest['aria-selected'];
  return (
    <div
      className={classNames(className, classes.root)}
      {...rest}
    >
      <div className={classes.labelContainer}>
        {isMissingData && <MissingDataBubble tooltipText="This section is missing data." />}
        <div>{children}</div>
      </div>
      {SubtitleComponent}
      <div className={classNames(classes.historyContainer, {
        [classes.historyContainerSelected]: selected,
      })}
      >
        <HistoryIcon className={classes.historyIcon} />
        {lastUpdateTime}
      </div>
    </div>
  );
};

PlanningDataTab.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  lastUpdateTime: PropTypes.string.isRequired,
  isMissingData: PropTypes.bool.isRequired,
  SubtitleComponent: PropTypes.object,
};

PlanningDataTab.defaultProps = {
  className: '',
  SubtitleComponent: null,
};

export default withStyles(styles)(PlanningDataTab);
